import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { VehicleEntity } from '@domain/dto/vehicle/vehicle-get.dto';
import { map, mergeMap, Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';
import { VehicleMapper } from './vehicle.mapper';

@Injectable()
export class VehicleRepository extends BaseLocalRepository {
  private mapper = new VehicleMapper();
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.VEHICLES);
  }
  get(params: any): Observable<VehicleEntity> {
    return this.getRequest<VehicleEntity[]>(params)
      .pipe(mergeMap((item) => item.Data))
      .pipe(map(this.mapper.fromJson));
  }
}
